import { Modal } from "react-bootstrap";
import { BiSupport } from "react-icons/bi";
import Cookies from "js-cookie";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;

const whatsappNo = customerData?.SalesPersonMobileNo?.trim()
  ? customerData.SalesPersonMobileNo
  : "9867939900";

const NoCodeModal = ({ show, onHide }) => {
  const onCloseModal = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={onCloseModal} className="login_modal" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Limited Access
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-icon">
          <BiSupport size="40px" />
        </div>
        <p className="modal-message">
          Order placement is currently unavailable for your account. Please
          reach out to your representative or our sales team for further
          assistance
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="close_btn" onClick={onCloseModal}>
          Close
        </button>
        <a
          href={`https://api.whatsapp.com/send?phone=91${whatsappNo}&text=Hi%27,%20like%20to%20chat%20with%20you`}
          target="_blank"
          rel="noreferrer"
          className="login_btn"
        >
          Contact Now
        </a>
      </Modal.Footer>
    </Modal>
  );
};

export default NoCodeModal;
